module.exports = __webpack_public_path__ + "img/big_11B25_blue.d0082e42.png";